import TeamContainer from "../../../components/pages/other/team";

const Team = () => {
  return <TeamContainer />;
};

export default Team;
